import React, { useEffect, useState } from 'react';
import { indicatorsApi } from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Loader2, Plus, Boxes, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function Indicators() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ code: '', name: '', unit: '', category: 'general', description: '' });

  const load = () => { setLoading(true); indicatorsApi.list().then(r => setItems(r.data)).finally(() => setLoading(false)); };
  useEffect(load, []);

  const create = async () => {
    try { await indicatorsApi.create(form); toast.success('Indicador creado'); setOpen(false); setForm({ code: '', name: '', unit: '', category: 'general', description: '' }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Error'); }
  };
  const remove = async (code) => {
    if (!window.confirm(`Eliminar indicador ${code}?`)) return;
    try { await indicatorsApi.remove(code); toast.success('Eliminado'); load(); }
    catch { toast.error('Error'); }
  };

  const grouped = items.reduce((acc, i) => { (acc[i.category] = acc[i.category] || []).push(i); return acc; }, {});

  return (
    <div className="space-y-4 animate-fade-in-up">
      <Card className="aea-card">
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2"><Boxes className="w-5 h-5 text-aea-blue" /> Indicadores del sector aluminio</CardTitle>
            <p className="text-sm text-slate-500 mt-1">Configuración de las métricas que las empresas deben reportar cada mes.</p>
          </div>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button className="bg-aea-blue hover:bg-aea-blue-dk" data-testid="btn-new-indicator"><Plus className="w-4 h-4 mr-2" /> Nuevo indicador</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Nuevo indicador</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Código (único, sin espacios)</Label><Input placeholder="EJ. RENDIMIENTO_KG_H" value={form.code} onChange={e => setForm({ ...form, code: e.target.value.toUpperCase() })} data-testid="ind-code" /></div>
                <div><Label>Nombre</Label><Input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="ind-name" /></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Unidad</Label><Input placeholder="kg, kWh, €, m²" value={form.unit} onChange={e => setForm({ ...form, unit: e.target.value })} data-testid="ind-unit" /></div>
                  <div><Label>Categoría</Label><Input value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} data-testid="ind-cat" /></div>
                </div>
                <div><Label>Descripción</Label><Input value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} data-testid="ind-desc" /></div>
                <Button className="w-full bg-aea-blue hover:bg-aea-blue-dk" onClick={create} data-testid="btn-create-indicator">Crear</Button>
              </div>
            </DialogContent>
          </Dialog>
        </CardHeader>
        <CardContent>
          {loading ? <div className="flex justify-center py-10"><Loader2 className="animate-spin text-aea-blue" /></div> :
            <div className="space-y-4">
              {Object.entries(grouped).map(([cat, list]) => (
                <div key={cat}>
                  <div className="text-xs uppercase tracking-widest text-aea-blue font-semibold mb-2">{cat}</div>
                  <div className="grid md:grid-cols-2 gap-2">
                    {list.map(i => (
                      <div key={i.code} className="flex items-center justify-between border border-slate-200 rounded-md p-3" data-testid={`ind-row-${i.code}`}>
                        <div>
                          <div className="font-medium text-sm">{i.name}</div>
                          <div className="text-xs text-slate-500 font-mono">{i.code} · {i.unit}</div>
                        </div>
                        <Button variant="ghost" size="icon" onClick={() => remove(i.code)} className="text-slate-400 hover:text-red-600" data-testid={`btn-del-ind-${i.code}`}><Trash2 className="w-4 h-4" /></Button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          }
        </CardContent>
      </Card>
    </div>
  );
}
